import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LandingRouting} from "./landing.routing";
import {LandingComponent} from "./landing.component";
import {TranslateModule} from "@ngx-translate/core";
import {SharedModule} from "@city-tax/shared";

@NgModule({
  imports: [CommonModule, LandingRouting, SharedModule, TranslateModule],
  declarations: [LandingComponent],
})
export class LandingModule {


}
